<template>
  <div class="pending-offer">
    <div class="row">
      <div class="col-3 pending-offer-logo"><img :src="logoURL" v-if="logoURL" /></div>
      <div class="col-7 pending-offer-title">{{title}}</div>
      <div class="col-2 loading">
        <img :src="loadingImg" v-if="submitting" />
        <div v-else><button class="btn btn-danger cancel-offer" @click="cancelOffer">x</button></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PendingOffer',
  props: ['offer', 'submitting'],
  components: {
  },
  data () {
    return {
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  computed: {
    logoURL () {
      return this.offer.logoURL
    },
    title () {
      return this.offer.name
    }
  },
  methods: {
    cancelOffer () {
      this.$emit('cancelOffer')
    }
  }
}
</script>

<style scoped>
.pending-offer {
  padding-top: 10px;
}
.pending-offer-logo img {
  max-width: 100%;
  max-height: 45px;
  width: auto;
  height: auto;
}
.loading img {
  height: 18px;
  margin-top: -2px;
  float: right;
}
</style>
